import { Check } from '@mui/icons-material'
import { useState } from 'react'

type Props = {
  onClick: () => void
  active: boolean
  text: string
}

export const MenuItem = ({ onClick, active, text }: Props) => {
  const [hover, setHover] = useState(false)

  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        width: '100%',
        height: '28px',
        padding: '4px',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        border: 'none',
        cursor: 'pointer',
        color: '#65768B',
        backgroundColor: hover ? 'rgba(0, 0, 0, 0.06)' : '#EBECED',
        transition: 'all 0.2s cubic-bezier(0.3, 0.3, 0.3, 1)',
        whiteSpace: 'nowrap',
      }}
    >
      <div
        style={{
          width: '20px',
          height: '20px',
        }}
      >
        {active && <Check fontSize='small' />}
      </div>
      <span style={{ padding: '0 8px' }}>{text}</span>
    </button>
  )
}
